// Thousands are grouped with a period (e.g. "1.234"), matching es-ES grouping,
// regardless of the active UI language. useGrouping must be forced to 'always':
// with the 'auto' default, es-ES's CLDR data uses "min2" grouping, which skips
// the separator for any 4-digit number whose leading group is a single digit
// (e.g. 7829 renders as "7829", not "7.829", while 78290 renders fine).
// `as any`: this TS version's NumberFormatOptions type still types useGrouping
// as boolean-only, but the string values ('always' etc.) are real and supported
// at runtime (ECMA-402 / Intl.NumberFormat v3).
export const formatNumber = (value: number): string =>
    value.toLocaleString('es-ES', {maximumFractionDigits: 0, useGrouping: 'always'} as any)
